import deepEqual from 'fast-deep-equal'
const tags = require('../../assets/tag-config.json');

export const state = () => ({
  docId: null,
  title: null,
  colTitle: null,
  colRole: null,
  collections: [],
  tagDefs: tags,
  documents: [],
})


export const mutations = {
  update(state, params) {
    for (const key in params)
      if (!deepEqual(state[key], params[key])) state[key] = params[key]
  }
}

export const actions = {
  update({ commit }, params) {
    commit('update', params)
  },
  setCollections({ dispatch, state }, { collections }) {
    dispatch('update', { collections: collections })
  },
  setTagDefs({ dispatch, state }, { tagDefs }) {
    dispatch('update', { tagDefs: tagDefs })
  },
  setDocuments({ dispatch, state }, { documents }) {
    dispatch('update', { documents: documents })
  },
  setColTitle({ dispatch, state }, { colTitle }) {
    dispatch('update', { colTitle: colTitle })
  },
  setColRole({ dispatch, state }, { colRole }) {
    dispatch('update', { colRole: colRole })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};